export const procedure = {
  id: undefined,
  start_date: '',
  receive_date: '',
  name: '',
  description: '',
  object_resources: [],
  procedure_stages: []
}

export const procedureStage = {
  name: '',
  start_date: '',
  end_date: '',
  description: '',
  result: ''
}
